(ns frontend.ui.component.lp-portal.file-upload.view
  (:require
   [herb.core :refer [<class]]
   [frontend.utils :as fu]
   [frontend.ui.component.lp-portal.file-upload.style :as style]
   [goog.string :as gstring]))

(defn file-upload
  [{:keys [on-file uploading uploaded accept on-type-url-click] :as props}]
  (if uploading
    [:div
     {:class (<class style/status)}
     (if uploading
       "Uploading..."
       "Uploaded.")]
    [:div
     {:class        (<class style/container)
      :on-drag-over fu/prevent-default-event!
      :on-change    (fn [e]
                      (fu/prevent-default-event! e)
                      (on-file (-> e
                                   .-target
                                   .-files
                                   (first))))
      :on-drop      (fn [e]
                      (fu/prevent-default-event! e)
                      (on-file (-> e
                                   .-dataTransfer
                                   .-files
                                   (first))))}
     [:label
      {:for   :file-input
       :class (<class style/upload-input-label)}
      (when uploaded
        [:div
         {:class (<class style/image-uploaded-text)}
         "Image uploaded."
         (gstring/unescapeEntities "&nbsp;")])
      [:div
       "Drag and drop"
       (if on-type-url-click ", " " or ")
       [:span
        {:class (<class style/text-link)}
        "browse"]
       (when on-type-url-click " or ")
       (when on-type-url-click
         [:span
          {:on-click (fn [e]
                       (.preventDefault e)
                       (on-type-url-click))
           :class    (<class style/text-link)}
          "type URL"])
       "."]
      [:input
       {:id     :file-input
        :type   "file"
        :accept accept
        :class  (<class style/upload-input)}]]]))
